import React from 'react';
import Icon, { IconProps } from './Icon';

const TopicalsIcon: React.FC<IconProps> = ({ size = 28, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 28 28" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.1044 2.16375C20.2499 2.29036 20.3334 2.47379 20.3334 2.66667V2.837C20.3334 8.01341 19.7919 13.1632 18.7253 18.1241L18.62 18.6139L18.1151 21.2307C18.1136 21.2392 18.112 21.2476 18.1102 21.2559L17.2991 25.4596C17.2386 25.7733 16.964 26 16.6445 26H11.3556C11.0361 26 10.7616 25.7733 10.701 25.4596L9.38016 18.6139L8.98429 16.7726C8.11038 12.7079 7.66675 8.48878 7.66675 4.24807C7.66675 3.91547 7.91188 3.63376 8.24128 3.5878L19.5746 2.0064C19.7656 1.97975 19.9589 2.03713 20.1044 2.16375ZM16.9079 20.4496H12.7408C12.3726 20.4496 12.0742 20.7481 12.0742 21.1163C12.0742 21.4845 12.3726 21.7829 12.7408 21.7829H16.6506L16.0942 24.6667H11.906L10.688 18.3543C10.6871 18.3497 10.6862 18.3451 10.6852 18.3405L10.2878 16.4923C9.47391 12.7066 9.04144 8.7806 9.00291 4.82777L18.9976 3.43316C18.9577 8.31619 18.4272 13.1672 17.4217 17.8439L17.315 18.3405C17.314 18.3451 17.313 18.3497 17.3122 18.3543L16.9079 20.4496Z"
        fill={color}
      />
    </Icon>
  );
};

export default TopicalsIcon;

